import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GetSingleProduct } from "../../../../APIs/Function/Product/GetSingleProduct";
import CustomButton from "../../../../Components/Button/CustomButton";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import Loader2 from "../../../../Components/Loader/Loader2";

const SingleProduct = () => {
  const [singleProduct, setSingleProduct] = useState({});
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const handleSingleProduct = async () => {
    try {
      setLoading(true);
      let res = await GetSingleProduct(id);
      setSingleProduct(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleProduct();
  }, []);
  console.log(singleProduct);
  return (
    <>
      {" "}
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader2 />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/product"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Product Details
              </Typography>
            </Box>
            <Box>
              <Link to={`/editproduct/${singleProduct.id}`}>
                <CustomButton
                  sx={{
                    width: { xs: "40px", md: "50px", lg: "80px" },
                    height: { xs: "10px", md: "50px", lg: "50px " },
                    transition: "transform 0.3s",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  Edit
                </CustomButton>
              </Link>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              height: "80vh",
              pX: 4,
              pY: 1,
              boxSizing: "border-box",
              justifyContent: "center ",
            }}
          >
            {/* image box */}
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                mt: "30px",
                border: "1px solid #E8E8E8",
                width: "50%",
                boxSizing: "border-box",
                p: 5,
                flexWrap: "wrap",
                overflow: "auto",
              }}
            >
              {singleProduct?.product_images?.map((e, i) => (
                <Box sx={{ width: "150px", height: "150px" }}>
                  <img
                    width={"100%"}
                    height={"100%"}
                    src={`https://api.qhealth.com.au/upload/images/${e.p_images}`}
                    alt=""
                  />
                </Box>
              ))}
            </Box>
            {/* details box */}
            <Box
              sx={{
                width: "50%",
                // border: "1px solid #E8E8E8",
                p: 4,
                boxSizing: "border-box",
                textAlign: "left",
              }}
            >
              <Box
                sx={{
                  p: 2,
                  boxSizing: "border-box",
                  border: "1px solid #E8E8E8",
                  width: "90%",
                }}
              >
                <Typography sx={{ fontFamily: "Inter", fontSize: "16px" }}>
                  Product Name : {singleProduct.product_name}
                </Typography>
              </Box>
              <Box
                sx={{
                  p: 2,
                  boxSizing: "border-box",
                  mt: 1,
                  border: "1px solid #E8E8E8",
                  display: "flex",
                  gap: "5px",
                  width: "90%",
                }}
              >
                <Typography sx={{ fontFamily: "Inter", fontSize: "16px" }}>
                  Description :
                </Typography>
                <Typography
                  sx={{ fontFamily: "Inter", fontSize: "16px", width: "75%" }}
                >
                  {singleProduct.description}
                </Typography>
              </Box>
              <Box
                sx={{
                  p: 2,
                  boxSizing: "border-box",
                  mt: 1,
                  border: "1px solid #E8E8E8",
                  width: "90%",
                }}
              >
                <Typography sx={{ fontFamily: "Inter", fontSize: "16px" }}>
                  Actual Price : {singleProduct.actual_price}
                </Typography>
              </Box>
              <Box
                sx={{
                  p: 2,
                  boxSizing: "border-box",
                  mt: 1,
                  border: "1px solid #E8E8E8",
                  width: "90%",
                }}
              >
                <Typography sx={{ fontFamily: "Inter", fontSize: "16px" }}>
                  Available Stock : {singleProduct.available_stock}
                </Typography>
              </Box>
              <Box
                sx={{
                  p: 2,
                  boxSizing: "border-box",
                  mt: 1,
                  width: "90%",
                  border: "1px solid #E8E8E8",
                }}
              >
                <Typography sx={{ fontFamily: "Inter", fontSize: "16px" }}>
                  Discounte Price : {singleProduct.discount_price}
                </Typography>
              </Box>
            </Box>
          </Box>{" "}
        </Box>
      )}
    </>
  );
};

export default SingleProduct;
